import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { navbarRoutes } from "../constant.js";
import "./MobileMenu.css";

const MobileMenu = () => {
    const { pathname } = useLocation();
    const [open, setOpen] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return (
        <>
            {/* Hamburger (mobile only) */}
            <div
                className={`mobile-hamburger ${open ? "active" : ""}`}
                onClick={() => setOpen(true)}
            >
                <span></span>
                <span></span>
                <span></span>
            </div>

            {/* Sidebar */}
            <div className={`mobile-sidebar ${open ? "open" : ""}`}>
                <button className="close-btn" onClick={() => setOpen(false)}>
                    ✕
                </button>

                {navbarRoutes.map(
                    (route) => <Link className={pathname === route.path ? 'matched-route' : ''} to={route.path} onClick={() => setOpen(false)}>{route.label}</Link>
                )}
                {/* <a href="/" onClick={() => setOpen(false)}>Home</a>
                <a href="/projects" onClick={() => setOpen(false)}>Projects</a>
                <a href="/pricing" onClick={() => setOpen(false)}>Payment</a>
                <a href="/contact" onClick={() => setOpen(false)}>Contact Us</a> */}
            </div>

            {/* Overlay */}
            {open && (
                <div
                    className="mobile-overlay"
                    onClick={() => setOpen(false)}
                ></div>
            )}
        </>
    );
}

export { MobileMenu };